define.alias("shared/components/shared/post/secondary/hashtag-suggestions/wrapper", "media/components/shared/post/secondary/hashtag-suggestions/wrapper");